export const APP_THEME_COLORS = {
  10: '#f8f7f7',
  20: '#1a171b',
  30: '#004a6b',
  40: '#f6bf00',
  50: '#aaaaaa',
}
